<template>
    <a-row style="margin-top: 12px">
        <a-pagination
                style="float:right;font-size: 17px"
                :hideOnSinglePage="true"
                show-quick-jumper
                :default-current="data.pageIndex"
                :pageSize=10
                :total="data.totalCount"
                @change="onChange"
        />
    </a-row>
</template>

<script>
    export default {
        name: "MyPage",
        data() {
            return {}
        },
        methods: {
            onChange(page) {
                this.$emit('change', page);
            }
        },
        props: {
            data: {
                type: Object,
                default() {
                    return {}
                }
            }
        }
    }
</script>

<style scoped>
</style>
